export class Emissao{
    id: number;
    numeroPedido: string; 
    nomeAmigavel: string;
    codigoReferencia: string;
    pinUsuario: string;
    tokenOtpUsuario: string;
    nome: string;
    cpf: string;
    idUsuario: number;
    telefone: string;
    paginasTermo: string[] = [];
    email: string = '';
    documento: string = '';
    pinTemporario: string = '';
    confirmaPin: string = '';
    etokenDefinido: boolean;
    palavras: string[] = [];
    usuarioCadastrado: boolean;
    pinDefinido: boolean;
    pedidoEncontrado: boolean;
    cnpj: string = '';
    razaoSocial: string = '';
    idAgenteRegistro: number;
    cpfAgenteRegistro: string = '';
    usuarioAtivado: boolean;
    idOrganizacao: number;
    usareToken: boolean;
    token: string;
    idCertificadoComunicacao: number;
    codigoGrupo: string;
    codigoProduto: string;

}